import axios from 'axios'
import {functionExist, isNullOrUndefined} from 'cgil-html-utils'
import {BASE_REST_API_URL, DEV, getLog} from './config'

const log = getLog('demandePODP', 4, 1)

let instance = null
// Demande de Permis Occupation domaine public
class DemandePoDP {
  constructor () {
    if (!instance) {
      instance = this
    }
    // to test whether we have singleton or not and store how old is data
    this.time = new Date()
    this.myMap = new Map()
    this.isReady = false
    this.lastError = null
    this.lastErrorMsg = null
    return instance
  }

  getListDemandes (callbackLoaded) {
    axios.get(`${BASE_REST_API_URL}/demandes`)
    .then(resp => {
      this.lastError = null
      this.lastErrorMsg = null
      log.l(`## IN DemandePoDP.getListDemandesresponse is :`, resp.data)
      this.isReady = true
      if (functionExist(callbackLoaded)) {
        callbackLoaded(resp.data)
      }
    })
    .catch(err => {
      this.isReady = false
      log.e(`## ERROR IN DemandePoDP.getListDemandesresponse while retrieving data with axios.get `)
      if (err.response) {
        log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response)
        this.lastErrorMsg = ` DemandePoDP.getListDemandesresponse : La requete http a recu en retour un code status=${err.response.status} >2xx ! `
        this.lastError = err.response
      } else if (err.request) {
        log.e(' -- The request was made, but no response was received from the server', err.request)
        this.lastErrorMsg = ` DemandePoDP.getListDemandesresponse : La requete http n'a pas reçu de reponse du serveur ! `
        this.lastError = err.request
      } else {
        log.e(' -- Something happened in setting up the request that triggered an Error', err.message)
        this.lastErrorMsg = ` DemandePoDP.getListDemandesresponse : La requete http est erronée et n'a pas pu se faire! `
        this.lastError = err.message
      }
      if (functionExist(callbackLoaded)) {
        callbackLoaded(`## ERROR IN DemandePoDP.getListDemandesresponse while retrieving data with axios.get`)
      }
      return false
    })
  }

  // public method to get initial data for this demand using cached entries if they exist
  getDemandeInitiale (guid, callbackLoaded) {
    if (isNullOrUndefined(guid)) {
      log.w(`## ERROR IN DemandePoDP.getDemandeInitiale : guid is ${guid}  !`)
      this.isReady = false
      return false
    }
    if (this.myMap.has(guid)) {
      log.l(`## IN DemandePoDP.getDemandeInitiale(${guid}) serving data from cache`)
      this.lastError = null
      this.lastErrorMsg = null
      this.isReady = true
      return this.myMap.get(guid)
    } else {
      this.isReady = false
      log.l(`## IN IN DemandePoDP.getDemandeInitiale(${guid})  retrieving  data from server`)
      this._getData(callbackLoaded, guid)
      return false
    }
  }

  getdemandeEnCours (id, callbackLoaded) {
    axios.get(`${BASE_REST_API_URL}/demandeencours/${id}`)
    .then(resp => {
      this.lastError = null
      this.lastErrorMsg = null
      log.l(`## IN DemandePoDP.isDemandeAlreadysaved(${id}) response is :`, resp.data[0])
      this.isReady = true
      if (functionExist(callbackLoaded)) {
        callbackLoaded(resp.data[0])
      }
    })
    .catch(err => {
      this.isReady = false
      log.e(`## ERROR IN DemandePoDP.getdemandeEnCours(${id}) while retrieving data with axios.get `)
      if (err.response) {
        log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response)
        this.lastErrorMsg = ` DemandePoDP.getdemandeEnCours(${id}): La requete http a recu en retour un code status=${err.response.status} >2xx ! `
        this.lastError = err.response
      } else if (err.request) {
        log.e(' -- The request was made, but no response was received from the server', err.request)
        this.lastErrorMsg = ` DemandePoDP.getdemandeEnCours(${id}): La requete http n'a pas reçu de reponse du serveur ! `
        this.lastError = err.request
      } else {
        log.e(' -- Something happened in setting up the request that triggered an Error', err.message)
        this.lastErrorMsg = ` DemandePoDP.getdemandeEnCours(${id}): La requete http est erronée et n'a pas pu se faire! `
        this.lastError = err.message
      }
      if (functionExist(callbackLoaded)) {
        callbackLoaded(`## ERROR IN DemandePoDP.isDemandeAlreadysaved(${id}) while retrieving data with axios.get`)
      }
      return false
    })
  }

  isDemandeAlreadysaved (id, callbackLoaded) {
    axios.get(`${BASE_REST_API_URL}/demandesauvee/${id}`)
    .then(resp => {
      this.lastError = null
      this.lastErrorMsg = null
      log.l(`## IN DemandePoDP.isDemandeAlreadysaved(${id}) response is :`, resp.data)
      this.isReady = true
      if (functionExist(callbackLoaded)) {
        callbackLoaded(resp.data)
      }
    })
    .catch(err => {
      this.isReady = false
      log.e(`## ERROR IN DemandePoDP.isDemandeAlreadysaved(${id}) while retrieving data with axios.get `)
      if (err.response) {
        log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response)
        this.lastErrorMsg = ` DemandePoDP.isDemandeAlreadysaved(${id}): La requete http a recu en retour un code status=${err.response.status} >2xx ! `
        this.lastError = err.response
      } else if (err.request) {
        log.e(' -- The request was made, but no response was received from the server', err.request)
        this.lastErrorMsg = ` DemandePoDP.isDemandeAlreadysaved(${id}): La requete http n'a pas reçu de reponse du serveur ! `
        this.lastError = err.request
      } else {
        log.e(' -- Something happened in setting up the request that triggered an Error', err.message)
        this.lastErrorMsg = ` DemandePoDP.isDemandeAlreadysaved(${id}): La requete http est erronée et n'a pas pu se faire! `
        this.lastError = err.message
      }
      if (functionExist(callbackLoaded)) {
        callbackLoaded(`## ERROR IN DemandePoDP.isDemandeAlreadysaved(${id}) while retrieving data with axios.get`)
      }
      return false
    })
  }

  saveDemande (guid, data, callbackSaved) {
    log.l(`## IN DemandePoDP.saveDemande(${guid}) will save data to server`)
    log.l(`## IN DemandePoDP.saveDemande(${guid}) data :`, data)
    // axios.post(`${BASE_REST_API_URL}/goposttesting.php`, data)
    // axios.post('https://httpbin.org/post', dataWithSession)
    axios.post(`${BASE_REST_API_URL}/gosavedemande.php`, data)
    .then(resp => {
      log.l(`## IN DemandePoDP.saveDemande AFTER saving data for guid :${guid} with axios.post`, resp.data)
      log.l(`## IN DemandePoDP.saveDemande AFTER saving data response :`, resp)
      if (functionExist(callbackSaved)) {
        callbackSaved(resp.data)
      }
    })
    .catch(err => {
      this.isReady = false
      if (err.response) {
        log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response)
        this.lastErrorMsg = ` DemandePoDP.saveDemande: La requete http a recu en retour un code status=${err.response.status} >2xx ! `
        this.lastError = err.response
      } else if (err.request) {
        log.e(' -- The request was made, but no response was received from the server', err.request)
        this.lastErrorMsg = ` DemandePoDP.saveDemande: La requete http n'a pas reçu de reponse du serveur ! `
        this.lastError = err.request
      } else {
        log.e(' -- Something happened in setting up the request that triggered an Error', err.message)
        this.lastErrorMsg = ` DemandePoDP.saveDemande: La requete http est erronée et n'a pas pu se faire! `
        this.lastError = err.message
      }
      if (functionExist(callbackSaved)) {
        callbackSaved(`## ERROR in DemandePoDP.saveDemande while saving data for guid :${guid} !
              SERVER SAY : ${JSON.stringify(this.lastError.data)}`)
      }
      // log.e(`## ERROR IN DemandePoDP.saveDemande while saving data for guid :${guid} with axios.post`, err.response)
      return false
    })
  }

  /***
   * submitDemande doit etre appeler quand l'utilisateur veut envoyer definitivement le formulaire de demande
   * @param guid
   * @param data
   * @param callbackSaved
   */
  submitDemande (guid, data, callbackSaved) {
    log.l(`## IN DemandePoDP.submitDemande(${guid}) will submit data to server`)
    log.l(`## IN DemandePoDP.submitDemande(${guid}) data :`, data)
    // TODO : ici on peu verifier REGLES VALIDATIONS respectees DES QUE STEVE MICHAUD LE CHEF PROJET NOUS LES DONNERA !
    // axios.post(`${BASE_REST_API_URL}/goposttesting.php`, data)
    // axios.post('https://httpbin.org/post', dataWithSession)
    axios.post(`${BASE_REST_API_URL}/gosavedemande.php`, data)
      .then(resp => {
        log.l(`## IN DemandePoDP.submitDemande AFTER saving data for guid :${guid} with axios.post`, resp.data)
        log.l(`## IN DemandePoDP.submitDemande AFTER saving data response :`, resp)
        if (functionExist(callbackSaved)) {
          callbackSaved(resp.data)
        }
      })
      .catch(err => {
        this.isReady = false
        if (err.response) {
          log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response)
          this.lastErrorMsg = ` DemandePoDP.submitDemande: La requete http a recu en retour un code status=${err.response.status} >2xx ! `
          this.lastError = err.response
        } else if (err.request) {
          log.e(' -- The request was made, but no response was received from the server', err.request)
          this.lastErrorMsg = ` DemandePoDP.submitDemande: La requete http n'a pas reçu de reponse du serveur ! `
          this.lastError = err.request
        } else {
          log.e(' -- Something happened in setting up the request that triggered an Error', err.message)
          this.lastErrorMsg = ` DemandePoDP.submitDemande: La requete http est erronée et n'a pas pu se faire! `
          this.lastError = err.message
        }
        if (functionExist(callbackSaved)) {
          callbackSaved(`## ERROR in DemandePoDP.submitDemande while saving data for guid :${guid} !
              SERVER SAY : ${JSON.stringify(this.lastError.data)}`)
        }
        // log.e(`## ERROR IN DemandePoDP.saveDemande while saving data for guid :${guid} with axios.post`, err.response)
        return false
      })
  }

  isDemandeCached (guid) {
    return this.myMap.has(guid)
  }

  // private method to retrieve data from server
  _getData (callbackLoaded, guid) {
    axios.get(`${BASE_REST_API_URL}/demande/${guid}`)
    .then(resp => {
      this.lastError = null
      this.lastErrorMsg = null
      this.myMap.set(guid, resp.data[0])
      this.isReady = true
      if (DEV) { log.l(`## IN DemandePoDP singleton after finish loading commune data for guid :${guid}`) }
      if (functionExist(callbackLoaded)) {
        callbackLoaded(this.myMap.get(guid))
      }
    })
    .catch(err => {
      // https://github.com/mzabriskie/axios#handling-errors
      this.isReady = false
      log.e(`## ERROR IN DemandePoDP._getData while retrieving data for guid :${guid} with axios.get `)
      if (err.response) {
        log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response)
        this.lastErrorMsg = ` DemandePoDP._getData: La requete http a recu en retour un code status=${err.response.status} >2xx ! `
        this.lastError = err.response
      } else if (err.request) {
        log.e(' -- The request was made, but no response was received from the server', err.request)
        this.lastErrorMsg = ` DemandePoDP._getData: La requete http n'a pas reçu de reponse du serveur ! `
        this.lastError = err.request
      } else {
        log.e(' -- Something happened in setting up the request that triggered an Error', err.message)
        this.lastErrorMsg = ` DemandePoDP._getData: La requete http est erronée et n'a pas pu se faire! `
        this.lastError = err.message
      }
      if (functionExist(callbackLoaded)) {
        callbackLoaded(`## ERROR IN DemandePoDP._getData while retrieving data for guid :${guid} with axios.get`)
      }
      return false
    })
  }
}
export const demandePoDP = new DemandePoDP()



// WEBPACK FOOTER //
// ./src/components/demandePoDP.js